/**
 * Yield control back to the browser so it can paint and handle other input.
 * Uses the Scheduler API where available, falling back to a macrotask which
 * still lets the browser slot in a paint between long pieces of work.
 */
function yieldToMain() {
  if (typeof window.scheduler?.yield === 'function') {
    return window.scheduler.yield();
  }
  return new Promise((resolve) => setTimeout(resolve, 0));
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.addToCart.bind(this));
    }
  }

  async addToCart(event) {
    event.preventDefault();

    const submitBtn = this.form.querySelector('button[type="submit"]');
    if (!submitBtn || submitBtn.classList.contains('loading')) return;

    // Cheap, immediate visual feedback.
    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.classList.add('loading');

    // Let the browser paint the loading state before we start the work,
    // so the click feels instant even if the main thread was busy.
    await yieldToMain();

    const formData = new FormData(this.form);

    try {
      const cartResponse = await CartApi.addToCart(formData, {
        variantData: this.form.dataset
      });
      await CartApi.refreshCart(cartResponse);

      // Split the (heavy) cart re-render from opening the drawer so they
      // run in separate frames instead of one long main-thread task.
      await yieldToMain();

      document.getElementById('custom-header-cart-trigger')?.click();
    } catch (error) {
      CartApi.showToast(error.message, true);
    } finally {
      submitBtn.removeAttribute('disabled');
      submitBtn.classList.remove('loading');
    }
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
